<form [formGroup]="configurationFormLinebasedAllAttributes">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="removeEmptyAttributes"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.remove-empty-attributes'
        | translate}}</label>
      <app-yes-no-group-button id="removeEmptyAttributes" formControlName="removeEmptyAttributes">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="countryCode"
        class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.country-code'
        | translate}}</label>
      <input id="countryCode" type="text" class="form-control" formControlName="countryCode" />
    </div>
    <div class="form-group col-md-4">
      <label for="sendLegacyNoAsItemNo"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.send-legacy-no-as-item-no'
        | translate}}</label>
      <app-yes-no-group-button id="sendLegacyNoAsItemNo" formControlName="sendLegacyNoAsItemNo">
      </app-yes-no-group-button>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="useTitleColumn"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.title-column'
        | translate}}</label>
      <app-yes-no-group-button id="useTitleColumn" formControlName="useTitleColumn">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="addTitleToAttributeDescription"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.add-title-to-attribute-description'
        | translate}}</label>
      <app-yes-no-group-button id="addTitleToAttributeDescription" formControlName="addTitleToAttributeDescription">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="titleAttributeSeparator"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.title-attribute-separator'
        | translate}}</label>
      <input id="titleAttributeSeparator" type="text" class="form-control" formControlName="titleAttributeSeparator" />
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="useUnitColumn"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.attribute-unit-column'
        | translate}}</label>
      <app-yes-no-group-button id="useUnitColumn" formControlName="useUnitColumn">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="addUnitToAttributeValue"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.add-unit-to-attribute-value'
        | translate}}</label>
      <app-yes-no-group-button id="addUnitToAttributeValue" formControlName="addUnitToAttributeValue">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="unitAttributeSeparator"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.attribute-unit-separator'
        | translate}}</label>
      <input id="unitAttributeSeparator" type="text" class="form-control" formControlName="unitAttributeSeparator" />
    </div>
  </div>

  <div class="denominators-heading">
    {{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.column-tag-denominators'
    | translate}}</div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="itemNumberDenominator"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.item-number-denominator'
        | translate}}</label>
      <input id="itemNumberDenominator" type="text" class="form-control" formControlName="itemNumberDenominator" />
    </div>
    <div class="form-group col-md-4">
      <label for="titleDenominator"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.title-denominator'
        | translate}}</label>
      <input id="titleDenominator" type="text" class="form-control" formControlName="titleDenominator" />
    </div>
    <div class="form-group col-md-4">
      <label for="attributeDescriptionDenominator"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.attribute-description-denominator'
        | translate}}</label>
      <input id="attributeDescriptionDenominator" type="text" class="form-control"
        formControlName="attributeDescriptionDenominator" />
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="attributeValueDenominator"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.attribute-value-denominator'
        | translate}}</label>
      <input id="attributeValueDenominator" type="text" class="form-control"
        formControlName="attributeValueDenominator" />
    </div>
    <div class="form-group col-md-4">
      <label for="unitDenominator"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.unit-denominator'
        | translate}}</label>
      <input id="unitDenominator" type="text" class="form-control" formControlName="unitDenominator" />
    </div>
    <div class="form-group col-md-4">
      <label for="attributeTag"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.attribute-tag'
        | translate}}</label>
      <input id="attributeTag" type="text" class="form-control" formControlName="attributeTag" />
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-8">
      <label for="additionalColumns"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.additional-columns'
        | translate}}</label>
      <input id="additionalColumns" type="text" class="form-control" formControlName="additionalColumns" />
    </div>
  </div>
</form>